module.exports = __webpack_public_path__ + "static/img/weizhong.635c53a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/weizhong.png
// module id = dulp
// module chunks = 69